import { DefaultSidebar } from "@excalidraw/excalidraw";

export const AppSidebar = () => <DefaultSidebar />;
